import Vue from "vue";
import VueRouter from "vue-router";
import Index from '../view/Index'
import Notes from "../components/Notes";
import Project from "../components/Project";
import leaveMsg from "../components/leaveMsg";
import AboutMe from "../components/AboutMe";
import ArticleContent from "../components/ArticleContent";
import BlogInput from "../components/admin/BlogInput";
import Home from "../components/Home";
import AdminIndex from "../components/admin/AdminIndex";
import BlogManager from "../components/admin/BlogManager";
import AdminHome from "../components/admin/AdminHome";
import UserManager from "../components/admin/UserManager";
import CategoryManager from "../components/admin/CategoryManager";
import EssayManager from "../components/admin/EssayManager";
import ProjectManger from "../components/admin/ProjectManager"
import LeaveMsgManager from "../components/admin/LeaveMsgManager";
import AdminManager from "../components/admin/AdminManager";
import SkillManager from "../components/admin/SkillManager";
import HobbyManager from "../components/admin/HobbyManager";
import AssessManager from "../components/admin/AssessManager";
import AdminLogin from "../components/admin/AdminLogin";
import request from "../utils/axiosUtils";

Vue.use(VueRouter)
//获取原型对象上的push函数
const originalPush = VueRouter.prototype.push
//修改原型对象中的push方法
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
const router = new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '/',
      component: Index,
      name: 'Index',
      redirect: '/home',
      children: [
        {path: '/home', component: Home},
        {path: '/notes', component: Notes},
        {path: '/project', component: Project},
        {path: '/leaveMsg', component: leaveMsg},
        {path: '/aboutMe', component: AboutMe},
        {path: '/articleContent', component: ArticleContent, name: 'ArticleContent'},
      ]
    },
    {
      path: '/admin',
      component: AdminLogin,
      name: "AdminLogin",
    },
    {
      path: '/admin/index',
      component: AdminIndex,
      name: "AdminIndex",
      redirect: '/admin/home',
      children: [
        {path: '/admin/home', component: AdminHome, name: 'AdminHome'},
        {path: '/admin/blogManager', component: BlogManager, name: 'BlogManager'},
        {path: '/admin/userManager', component: UserManager, name: 'UserManager'},
        {path: '/admin/inputBlog', component: BlogInput, name: 'BlogInput'},
        {path: '/admin/categoryManager', component: CategoryManager, name: 'CategoryManager'},
        {path: '/admin/essayManager', component: EssayManager, name: 'EssayManager'},
        {path: '/admin/projectManager', component: ProjectManger, name: 'ProjectManger'},
        {path: '/admin/leaveMsg', component: LeaveMsgManager, name: 'LeaveMsgManager'},
        {path: '/admin/adminManager', component: AdminManager, name: 'AdminManager'},
        {path: '/admin/skill', component: SkillManager, name: 'SkillManager'},
        {path: '/admin/hobby', component: HobbyManager, name: 'HobbyManager'},
        {path: '/admin/assess', component: AssessManager, name: 'AssessManager'},
      ],
      beforeEnter: (to, from, next) => {
        let adminInfo = JSON.parse(window.sessionStorage.getItem("adminInfo"));
        if (to.path.startsWith("/admin/") && adminInfo !== null) {
          request({
            url: '/admin/login',
            method: 'post',
            params: {
              adminLoginInfo: adminInfo,
              isCheck: true
            }
          }).then(response => {
            let data = response.data.data;
            if (response.data.flag && data.account !== '' && data.password !== '') {
              next();
            } else {
              next("/");
            }
          })
        } else {
          next("/")
        }
      }
    }
  ]
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js